import { Button } from '@ixyberfree/ixybercomponents';
import { EventsIcon, FunctionIcon, PropertiesIcon } from 'Assets/icons';
import React from 'react';
import { styleCell, styleInput, styleRow, styleTable } from '../../styles';
import styles from './index.module.css';

interface IPropsTableForEdit {
    data: any;
    type: any;
    changeInput?: (id: string, propName: string, value: any) => void;
    openDictionaryObj?: (obj: any, typeKey: string, typeValue: string) => void;
    openRefDevice?: (refId: string) => void;
    openAddressList?: (id: string) => void;
    openExeFunc?: (id: string, returnType: any) => void;
    openEvents?: (eventId: string) => void;
    openBindings?: (eventId: string) => void;
    openPropertyEditor?: (key: string, typeStr: string) => void;
}

export const TableForEdit: React.FC<IPropsTableForEdit> = (props) => {
    let { data, type, changeInput, openDictionaryObj, openRefDevice, openPropertyEditor } = props;

    let arrTypes = ['System.String', 'System.Single', 'System.Int32', 'System.Double', 'System.Int64'];
    const dataTitle =
        'Используемые типы:\nstring, byte, sbyte, bool, char, decimal, double, float, int, uint, nint, long, ulong, short, ushort, enum \nПример: float[][], enum.yoko.mode';

    let [arr, setArr] = React.useState<JSX.Element[]>([]);

    enum TypeTableEnum {
        Properties,
        Events,
        Functions
    }

    let [typeTable, setTypeTable] = React.useState<TypeTableEnum>(TypeTableEnum.Properties);

    React.useEffect(() => {
        if (data !== undefined) {
            let tempArr = genTable(props);
            setArr([...tempArr]);
        }
    }, [data, typeTable]);

    function findType(typeArr: any, key: string) {
        return typeArr.filter((elem: any) => {
            return elem.Name === key;
        })[0];
    }

    const formatDate = (date: Date) => {
        let dateTimeLocalValue = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, -1);

        return dateTimeLocalValue;
    };

    const getSize = (value: any, num: number = 0): number | undefined => {
        if (typeof value === 'number') {
            return value + num;
        }
        if (Array.isArray(value)) {
            return Number(value.length.toString() + num);
        }
        return undefined;
    };

    function genTable(props: IPropsTableForEdit) {
        let {
            data,
            type,
            changeInput,
            openDictionaryObj,
            openRefDevice,
            openAddressList,
            openExeFunc,
            openEvents,
            openBindings
        } = props;
        let tData = data;
        let tempArr: JSX.Element[] = [];
        for (let key in tData) {
            let disInput = false;
            switch (key) {
                case 'ClassName': {
                    disInput = true;
                    break;
                }
                case 'path': {
                    disInput = true;
                    break;
                }
                case 'address': {
                    disInput = data.Enable;
                    break;
                }
            }

            let typeStr = findType(type, key)?.ReturnTypes[0];

            if (typeStr && typeStr.indexOf('System.Nullable`1[[') != -1) {
                typeStr = typeStr.substring(19, typeStr.search(','));
            }

            let hiddenProperty = ['Context'];
            if (typeTable == TypeTableEnum.Properties) {
                switch (typeStr) {
                    case 'System.Guid': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <input key={data.id + key} style={styleInput} defaultValue={tData[key]} disabled />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.String': {
                        if (hiddenProperty.indexOf(key) == -1) {
                            tempArr.push(
                                <tr style={styleRow} key={key}>
                                    <td style={styleCell}>{key}</td>
                                    <td style={styleCell}>
                                        <div
                                            className={key == 'type' ? styles.SystemStringDiv : ''}
                                            data-title={key == 'type' ? dataTitle : ''}
                                            style={{ display: 'flex' }}>
                                            <input
                                                className={key == 'type' ? styles.SystemStringInput : ''}
                                                style={styleInput}
                                                key={data.id + key + tData[key]}
                                                onBlur={(event) => {
                                                    if (tData[key] !== event.target.value && changeInput) {
                                                        changeInput(data.id, key, `${event.target.value}`);
                                                    }
                                                }}
                                                defaultValue={tData[key]}
                                                size={getSize(tData[key])}
                                                disabled={disInput}
                                            />
                                            {key == 'address' ? (
                                                <button
                                                    onClick={() => {
                                                        openAddressList && openAddressList(data.id);
                                                    }}
                                                    disabled={disInput}>
                                                    ...
                                                </button>
                                            ) : null}
                                        </div>
                                    </td>
                                </tr>
                            );
                        }
                        break;
                    }
                    case 'System.DateTime': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <input
                                        type="datetime-local"
                                        step={2}
                                        style={styleInput}
                                        key={data.id + key + tData[key]}
                                        onBlur={(event) => {
                                            tData[key] !== event.target.value &&
                                                changeInput &&
                                                changeInput(data.id, key, event.target.value);
                                        }}
                                        defaultValue={formatDate(new Date(tData[key]))}
                                        size={getSize(tData[key])}
                                        disabled={disInput}
                                    />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.TimeSpan': {
                        const bgColor =
                            tData['dT'] < tData['lastExeTime'] || tData['dT'] < tData['avgExeTime']
                                ? '#FF8D8D'
                                : '#FFF';
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={{ border: '1px solid #9F9F9F', background: bgColor }}>{key}</td>
                                <td style={styleCell}>
                                    <input
                                        style={styleInput}
                                        key={data.id + key + tData[key]}
                                        onBlur={(event) => {
                                            tData[key] !== event.target.value &&
                                                changeInput &&
                                                changeInput(data.id, key, `${event.target.value}`);
                                        }}
                                        defaultValue={tData[key]}
                                        size={getSize(tData[key])}
                                        disabled={disInput}
                                    />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.Object': {
                        tempArr.push(
                            <tr style={styleRow} key={key + 'row'}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell} key={key + 'cel'}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            style={styleInput}
                                            // key={tData[key]}
                                            key={data.id + key + tData[key]}
                                            onBlur={(event) => {
                                                let valTemp =
                                                    !isNaN(+event.target.value) && event.target.value != ''
                                                        ? Number(event.target.value)
                                                        : `${event.target.value}`;

                                                let valDef =
                                                    typeof tData[key] == 'string'
                                                        ? tData[key]
                                                        : JSON.stringify(tData[key]);

                                                if (valDef !== event.target.value && changeInput) {
                                                    changeInput(data.id, key, valTemp);
                                                }
                                            }}
                                            defaultValue={
                                                typeof tData[key] == 'string' ? tData[key] : JSON.stringify(tData[key])
                                            }
                                            size={getSize(tData[key], -10)}
                                        />
                                        <button
                                            onClick={() => {
                                                if (key == 'CV' && tData['type']) {
                                                    typeStr = tData['type'];
                                                }
                                                openPropertyEditor && openPropertyEditor(key, typeStr);
                                            }}>
                                            ...
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.Boolean': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <input
                                        key={data.id + key + tData[key]}
                                        onChange={(event) => {
                                            tData[key] !== event.target.checked &&
                                                changeInput &&
                                                changeInput(data.id, key, event.target.checked);
                                        }}
                                        type={'checkbox'}
                                        defaultChecked={tData[key]}
                                    />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.Double':
                    case 'System.Single': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <input
                                        type="text"
                                        style={styleInput}
                                        key={data.id + key + tData[key]}
                                        onBlur={(event) => {
                                            tData[key] !== event.target.value &&
                                                changeInput &&
                                                changeInput(data.id, key, Number(event.target.value));
                                        }}
                                        defaultValue={tData[key]}
                                        onInput={(e) => {
                                            e.currentTarget.value = e.currentTarget.value
                                                .replace(/[^0-9.s\-]/g, '')
                                                .replace(/(\..*)\./g, '$1');
                                        }}
                                        size={getSize(tData[key])}
                                    />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'System.UInt16':
                    case 'System.Int64':
                    case 'System.Int32':
                    case 'System.UInt32': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <input
                                        type="number"
                                        style={styleInput}
                                        key={data.id + key + tData[key]}
                                        onBlur={(event) => {
                                            if (key == 'writingInterval' && event.target.valueAsNumber < 100) {
                                                event.target.valueAsNumber = 100;
                                            }
                                            changeInput && changeInput(data.id, key, event.target.valueAsNumber);
                                            // tData[key] !== event.target.value && changeInput && changeInput(data.id, key, Number(event.target.value));
                                        }}
                                        defaultValue={tData[key]}
                                        min={key == 'writingInterval' ? '100' : undefined}
                                        onInput={(e) => {
                                            e.currentTarget.value = e.currentTarget.value.replace(/[^0-9\-]/g, '');
                                        }}
                                        size={getSize(tData[key])}
                                    />
                                </td>
                            </tr>
                        );
                        break;
                    }
                    case 'iXyberBaseLib.ExpressionBlock': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            key={tData[key].id}
                                            style={styleInput}
                                            defaultValue={tData[key].Expression}
                                            onBlur={(event) => {
                                                if (tData[key].Expression !== event.target.value && changeInput) {
                                                    changeInput(tData[key].id, 'Expression', `${event.target.value}`);
                                                }
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        );

                        break;
                    }
                    case 'iXyberBaseLib.SystemBase.RefObject': {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            key={tData[key].id}
                                            style={styleInput}
                                            defaultValue={tData[key].rpath}
                                            onBlur={(event) => {
                                                if (tData[key].rpath !== event.target.value && changeInput) {
                                                    changeInput(tData[key].id, 'rpath', `${event.target.value}`);
                                                }
                                            }}
                                        />
                                        <button
                                            onClick={() => {
                                                openRefDevice && openRefDevice(tData[key].id);
                                            }}>
                                            ...
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );

                        break;
                    }
                }

                if (typeStr && typeStr.indexOf('System.Collections.Generic.List`1[[iXyberBaseLib.Binding') > -1) {
                    tempArr.push(
                        <tr style={styleRow} key={key}>
                            <td style={styleCell}>{key}</td>
                            <td style={styleCell}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        key={data.id + key}
                                        style={styleInput}
                                        defaultValue={tData[key].length}
                                        disabled
                                    />
                                    <button
                                        onClick={() => {
                                            openBindings && openBindings(data.id);
                                        }}>
                                        ...
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                } else if (typeStr && typeStr.indexOf('System.Collections.Generic.Dictionary') > -1) {
                    //let pr = typeStr.slice(typeStr.indexOf('[[')).match(/\[([^\[\]]+)\]/g);
                    let pr: string = typeStr.slice(typeStr.indexOf('[[')).replace('[[', '[').replace(']]', ']');

                    let startSlice = 0;
                    let arrPr: string[] = [];
                    while (true) {
                        let endSlice: number = pr.indexOf('],', startSlice) + 1;
                        if (endSlice > 0) {
                            arrPr.push(pr.slice(startSlice, endSlice));
                            startSlice = endSlice + 1;
                        } else {
                            arrPr.push(pr.slice(startSlice));
                            break;
                        }
                    }
                    let typeKey = arrPr[0].slice(1, arrPr[0].length - 1).split(',')[0];
                    let typeObj = arrPr[1].slice(1, arrPr[1].length - 1).split(',')[0];
                    if (arrTypes.indexOf(typeObj) > -1) {
                        tempArr.push(
                            <tr style={styleRow} key={key}>
                                <td style={styleCell}>{key}</td>
                                <td style={styleCell}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            key={data.id + key}
                                            style={styleInput}
                                            defaultValue={tData[key]}
                                            disabled
                                        />
                                        <button
                                            onClick={() => {
                                                openDictionaryObj && openDictionaryObj(key, typeKey, typeObj);
                                            }}>
                                            ...
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    }
                }
            } else if (typeTable == TypeTableEnum.Events) {
                if (typeStr && typeStr == 'iXyberBaseLib.Events.EventElement') {
                    let value: string = '';
                    if (tData[key].RefObjects.length != 0) {
                        value = tData[key].RefObjects[0].rpathcv;
                    }

                    tempArr.push(
                        <tr style={styleRow} key={key}>
                            <td style={styleCell}>{key}</td>
                            <td style={styleCell}>
                                <div style={{ display: 'flex' }}>
                                    <input key={tData[key].id} value={value} style={styleInput} disabled />
                                    <button
                                        onClick={() => {
                                            openEvents && openEvents(tData[key].id);
                                        }}>
                                        ...
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                }
            }
        }

        if (type != null && typeTable == TypeTableEnum.Functions) {
            type.forEach((elem: any, key: number) => {
                if (elem.StructureType === 1) {
                    tempArr.push(
                        <tr style={styleRow} key={key}>
                            <td style={styleCell}>{'Func'}</td>
                            <td style={styleCell}>
                                <div style={{ display: 'flex' }}>
                                    <Button
                                        size="small"
                                        styleType="gray"
                                        key={elem.Name + key}
                                        text={elem.Name}
                                        onClick={() => {
                                            openExeFunc && openExeFunc(tData.id, elem);
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </td>
                        </tr>
                    );
                }
            });
        }

        return tempArr;
    }

    return (
        <div
            style={{
                width: '100%',
                height: '100%'
            }}>
            <div style={{ display: 'flex' }}>
                <PropertiesIcon
                    onClick={() => {
                        setTypeTable(TypeTableEnum.Properties);
                    }}
                    active={typeTable == TypeTableEnum.Properties}
                />
                <EventsIcon
                    onClick={() => {
                        setTypeTable(TypeTableEnum.Events);
                    }}
                    active={typeTable == TypeTableEnum.Events}
                />
                <FunctionIcon
                    onClick={() => {
                        setTypeTable(TypeTableEnum.Functions);
                    }}
                    active={typeTable == TypeTableEnum.Functions}
                />
            </div>
            <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
                <table style={styleTable}>
                    <tbody>{arr}</tbody>
                </table>
            </div>
        </div>
    );
};
